import { useCallback } from 'react';
import { ManualAlert } from '@conviva/portal-graphql-schema';

const useActions = ({
  setVisible,
  setEditAlert,
  setAlertToDelete,
  setConfirmationVisible
}) => {
  const onCancel = useCallback(() => {
    setVisible(false);
    setEditAlert({});
  }, [setVisible, setEditAlert]);

  const onCancelConfirmation = useCallback(() => {
    setAlertToDelete({});
    setConfirmationVisible(false);
  }, [setAlertToDelete, setConfirmationVisible]);

  const onDelete = useCallback((alert: ManualAlert) => {
    setConfirmationVisible(true);
    setAlertToDelete(alert);
  }, [setConfirmationVisible, setAlertToDelete]);

  const onEdit = useCallback((alert: ManualAlert) => {
    setVisible(true);
    setEditAlert(alert);
  }, [setVisible, setEditAlert]);

  const onCreate = useCallback(() => {
    setVisible(true);
    setEditAlert({});
  }, [setVisible, setEditAlert]);

  return {
    onCancel,
    onCancelConfirmation,
    onDelete,
    onEdit,
    onCreate,
  };
};

export default useActions;
